import styles from './PolicyPage.module.css';

function PrivacyPage() {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>개인정보처리방침</h1>
            <div className={styles.content}>
                <div className={styles.section}>
                    <h2>제1조 (수집하는 개인정보 항목)</h2>
                    <p>종합센터몰은 회원가입 및 서비스 제공을 위해 아래와 같은 개인정보를 수집합니다.</p>
                    <ul>
                        <li>필수항목: 이메일, 이름, 비밀번호, 전화번호</li>
                        <li>선택항목: 마케팅 수신 동의 여부</li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제2조 (개인정보 수집 및 이용 목적)</h2>
                    <ul>
                        <li>회원 식별 및 가입 의사 확인</li>
                        <li>서비스 제공 및 계약 이행 (주문, 결제, 배송)</li>
                        <li>고객 상담 및 불만 처리</li>
                        <li>법령상 의무 이행</li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제3조 (개인정보 보유 및 이용 기간)</h2>
                    <ul>
                        <li>회원 탈퇴 시까지</li>
                        <li>계약 또는 청약철회에 관한 기록: 5년 (전자상거래법)</li>
                        <li>대금결제 및 재화 공급에 관한 기록: 5년 (전자상거래법)</li>
                        <li>소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)</li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제4조 (동의 거부 권리 및 불이익)</h2>
                    <p>회원은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 단, 필수 항목 동의 거부 시 회원가입 및 서비스 이용이 제한됩니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>사업자 정보</h2>
                    <ul>
                        <li>상호: 종합센터몰</li>
                        <li>대표자: 김선진</li>
                        <li>사업자등록번호: 755-32-01468</li>
                        <li>이메일: isunjin74@naver.com</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPage;